import {IconButton, Modal} from "atmosfair-ui";
import React, {useState} from "react";
import {VALIDATE_FORM_STARTING_NUMBER} from "../../../constants/default-values";
import SaveBundleCreateJourneyDialogue
    from "../../../components/save-bundle-create-journey-dialogue/SaveBundleCreateJourneyDialogue";
import {createJourney, CreateJourneyProps} from "../../../redux/reducer/journey";
import {PATH_STRINGS} from "../../../routes/route-props";
import {AllActivityTypesArray} from "../../../types-enums/activity";
import {useAppDispatch, useAppSelector} from "../../../redux/reducer/store";
import {useNavigate} from "react-router-dom";
import {completeInitialCustomer} from "../../../components/forms/customer-form/CustomerForm";

interface CreateJourneyFromTravelComponentsButtonProps {
    activities: AllActivityTypesArray,
    disabled?: boolean
}

const CreateJourneyFromTravelComponentsButton = ({
                                                     activities,
                                                     disabled
                                                 }: CreateJourneyFromTravelComponentsButtonProps) => {
    const {customer, name, description} = useAppSelector(state => state.travelComponents)
    const [modalVisible, setModalVisible] = useState(false)
    const [validateForm, setValidateForm] = useState(VALIDATE_FORM_STARTING_NUMBER)
    const {agencies} = useAppSelector(state => state.user)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const _onCloseModal = () => {
        setModalVisible(false)
        setValidateForm(VALIDATE_FORM_STARTING_NUMBER)
    }

    return <>
        <IconButton
            disabled={disabled || activities.length === 0}
            tooltip={"SCREENS.TRAVEL_COMPONENTS_OVERVIEW.CREATE_JOURNEY"}
            color={"primary"}
            size={"large"}
            onlyIcon={true}
            icon={"suitcase"}
            onClick={() => setModalVisible(true)}/>
        {agencies && <Modal
            closeButtonText={"GENERAL.ABORT"}
            onBackdropClick={_onCloseModal}
            onClose={_onCloseModal}
            headline={"MODALS.CREATE_JOURNEY.TITLE"}
            showPaper={true}
            onConfirm={() => setValidateForm(validateForm + 1)}
            confirmButtonText={"GENERAL.CREATE"}
            onEnterKeyPressed={() => setValidateForm(validateForm + 1)}
            show={modalVisible}>
            <SaveBundleCreateJourneyDialogue
                persistJourneyInBackend={false}
                persistTravelComponentsInBackend={false}
                defaultValues={{
                    name: name ?? "",
                    description: description ?? "",
                    customer: customer ?? {...completeInitialCustomer},
                    personCount: null,
                    journeyDuration: null,
                    agency: null,
                }}
                showCompany={false}
                hideTravelComponents={false}
                createJourneyFromTravelComponents={true}
                onFormIsValid={data => {
                    dispatch(createJourney(data as CreateJourneyProps))
                    navigate(PATH_STRINGS.journey)
                }}
                validateForm={validateForm}
                agencies={agencies}
                activities={activities}/>
        </Modal>
        }
    </>
}

export default CreateJourneyFromTravelComponentsButton